import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Drawer, DrawerContent } from "./ui/drawer";
import { X } from "lucide-react";

interface ResponsiveModalProps {
  open: boolean;
  onClose: () => void;
  renderContent: () => React.ReactNode;
}

export default function ResponsiveModal({
  open,
  onClose,
  renderContent,
}: ResponsiveModalProps) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderCloseButton = () => {
    return (
      <div
        className="absolute top-2 end-2 h-10 w-10 bg-[#3f3f3f] hover:bg-[#505050] rounded-full flex items-center justify-center cursor-pointer"
        onClick={onClose}
      >
        <X className="w-6 h-6 text-white" />
      </div>
    );
  };

  const renderDialog = () => {
    return (
      <Dialog open={open} onOpenChange={onClose}>
        <DialogContent showCloseButton={false} className="p-0 bg-white gap-0">
          {renderContent()}
          {renderCloseButton()}
        </DialogContent>
      </Dialog>
    );
  };

  const renderDrawer = () => {
    return (
      <Drawer open={open} onOpenChange={onClose}>
        <DrawerContent className="bg-white max-h-[85vh] overflow-hidden flex flex-col">
          <div className="overflow-y-auto flex-1 overscroll-contain">
            {renderContent()}
          </div>
          {renderCloseButton()}
        </DrawerContent>
      </Drawer>
    );
  };

  return isDesktop ? renderDialog() : renderDrawer();
}
